import React, { ChangeEvent } from 'react';
import {
  TextField,
  OutlinedTextFieldProps,
  Box,
  Typography,
  MenuItem,
} from '@mui/material';

interface InputDefaultProps extends OutlinedTextFieldProps {
  onChangeData: (field: string, value: string) => void;
  labelName?: string;
  options?: { value: string; label: string }[];
}

export const SelectDefault: React.FC<InputDefaultProps> = ({
  onChangeData,
  size = 'small',
  labelName = '',
  variant = 'outlined',
  options = [],
  ...rest
}) => {
  const onChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    onChangeData(event.target.name, event.target.value);
  };

  return (
    <Box>
      {labelName && <Typography>{labelName}</Typography>}
      <TextField
        size={size}
        fullWidth
        onChange={onChange}
        color={'success'}
        variant={variant}
        select
        InputLabelProps={{
          shrink: true,
          style: { fontSize: 19 },
        }}
        SelectProps={{
          style: {
            height: 45,
          },
        }}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};
